export default __webpack_public_path__ + "static/media/logo-additional.b0ebea67.svg";